<template>
  <section class="page-terms-and-conditions prose">
    <div class="page-terms-and-conditions__body container">
      <LegalPagesNavigation />
      <div v-html="markdown" />
    </div>
  </section>
</template>

<script>
import LegalPagesNavigation from 'chimera/all/page/LegalPagesNavigation'
import { marked } from 'marked'
import AbstractTermsAndConditionsPage from './AbstractTermsAndConditionsPage'
import markdownFile from './markdown/de.md'

marked.setOptions({
  headerIds: false,
})

export default {
  name: 'TermsAndConditionsPage',

  components: {
    LegalPagesNavigation,
  },

  extends: AbstractTermsAndConditionsPage,

  /**
   * @returns {{markdown: (*|string|string)}}
   */
  data() {
    return {
      markdown: marked(markdownFile),
    }
  },
}
</script>
